import autosize from 'autosize';

const isValidMobileMenuTriggerEvent = (event) => {
    // Valid event types == Click, Enter(key), Space(key)
    return event.type === 'click' || (event.type === 'keydown' && (event.which === 13 || event.which === 32))
}

export default function() {
    //mobile nav controller

    // TODO: convert to vanilla JS
    $('.mobile-nav-trigger').on('click keydown', function (e) {
        if (isValidMobileMenuTriggerEvent(e)) {
            e.preventDefault()
            $(this).toggleClass('active');
            $('nav.nav').toggleClass('mobile-menu-open');
        }
    });

    //search logic
    $('.search-btn-trigger').on('click keydown', function (e) {
        if (isValidMobileMenuTriggerEvent(e)) {
            e.preventDefault()
            $('.search-container').slideDown(500);
            $('.search-container input').focus();
            $('body').addClass('overflow-hidden');
        }
    });

    $('.exit-search').on('click keydown', function (e) {
        if (isValidMobileMenuTriggerEvent(e)) {
            $('.search-container').slideUp(500);
            $('body').removeClass('overflow-hidden');
        }
    });

	autosize($('textarea')); // TODO: IS this needed?
}